'use strict';

var React = require('react');
//Components
var ContactDetails = require('./ContactDetails.jsx');
var Address = require('./Address.jsx');
var TextInput = require('../Common/TextInput.jsx');
//Action
var YourDetailsActions = require('../../actions/YourDetailsActions.js');

var YourDetailsConstants = require('../../constants/YourDetailsConstants.js');

var CorporateTrustee = React.createClass({
    updateYourDetailsData: function (event) {
        YourDetailsActions.updateYourDetailsData(event.target.model, event.target.id, event.target.value, this.props.index);
    },

    render: function () {
        return (
                <div>
                    <TextInput label="Full name of corporate trustee"
                               id={'ydTrustee' + 'corporateTrustee' + this.props.index}
                               value={this.props.data.corporateTrustee}
                               onBlur={this.updateYourDetailsData}
                               model="corporateTrustee"
                               errorList={this.props.errorList} 
                               isDisabled={this.props.data.businessNameReadonly}/>
                    <TextInput label={this.props.abnLabel}
                               id={'ydTrustee' + 'abn'+ this.props.index}
                               value={this.props.data.abn}
                               onBlur={this.updateYourDetailsData}
                               model="abn"
                               errorList={this.props.errorList}
                               mandatory={false} 
                               isDisabled={this.props.data.abnReadonly}/>
                    <Address index={this.props.index}
                             data={this.props.data.addressInfo}
                             section="ydTrustee"
                             accountType={this.props.accountType}
                             errorList={this.props.errorList}
                             type={YourDetailsConstants.Values.BUSINESS} />
                    <ContactDetails index={this.props.index}
                                    productId={this.props.productId}
                                    accountType={this.props.accountType}
                                    data={this.props.data}
                                    section="ydTrustee"
                                    isBusiness={true}
                                    errorList={this.props.errorList} />
                </div>
      );
    }
});

module.exports = CorporateTrustee;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/CorporateTrustee.jsx